import { useStore } from "@/state/store";
import { Avatar } from "@/components/atoms/Avatar";
import { Pill } from "@/components/atoms/Pill";
import { Icon } from "@/components/atoms/Icons";

export function ProfileView() {
  const userId = useStore((s) => s.userId);
  const userEmail = useStore((s) => s.userEmail);
  const setWalletOpen = useStore((s) => s.setWalletOpen);
  const setUser = useStore((s) => s.setUser);

  if (!userId) {
    return (
      <div className="card mx-6 my-6 flex flex-col items-center gap-3 py-16">
        <Icon.User size={28} className="text-muted" />
        <h3 className="text-[15px] font-semibold">Not signed in</h3>
        <button
          className="btn btn-primary"
          onClick={() => setWalletOpen(true)}
        >
          Sign in
        </button>
      </div>
    );
  }

  const displayName = userEmail ?? "trader";

  return (
    <div className="flex flex-col gap-6 px-4 pb-28 pt-4 sm:px-6 lg:pb-20">
      <div className="card flex items-center gap-5 p-6">
        <Avatar name={displayName} size={64} />
        <div className="flex-1">
          <div className="text-[18px] font-semibold">{displayName}</div>
          <div className="mt-1 text-[12px] text-muted">
            User ID <span className="font-mono">{userId.slice(0, 12)}…</span>
          </div>
          <div className="mt-2 flex gap-2">
            <Pill variant="accent">Tier 0 (T0)</Pill>
            <Pill>Verified email</Pill>
          </div>
        </div>
        <button
          className="btn"
          onClick={() => setUser(null, null)}
        >
          Sign out
        </button>
      </div>

      <section className="grid gap-3 md:grid-cols-3">
        <KycCard
          title="KYC tier"
          subtitle="Identity verification"
          actionLabel="Upgrade"
          desc="T0 lets you trade up to $1k cumulative. Upgrade to T1 for higher limits."
        />
        <KycCard
          title="Two-factor"
          subtitle="TOTP / backup codes"
          actionLabel="Enable"
          desc="Required for withdrawals over $5k. Strongly recommended."
        />
        <KycCard
          title="API keys"
          subtitle="Programmatic access"
          actionLabel="Generate"
          desc="Scoped keys with read/trade permissions. Coming soon."
        />
      </section>
    </div>
  );
}

function KycCard({
  title,
  subtitle,
  actionLabel,
  desc,
}: {
  title: string;
  subtitle: string;
  actionLabel: string;
  desc: string;
}) {
  return (
    <div className="card flex flex-col gap-3 p-4">
      <div>
        <div className="text-[13.5px] font-semibold">{title}</div>
        <div className="text-[11.5px] text-muted">{subtitle}</div>
      </div>
      <p className="text-[12.5px] text-text-2">{desc}</p>
      <div className="mt-auto">
        <button className="btn" disabled title="Coming soon">
          {actionLabel}
        </button>
      </div>
    </div>
  );
}
